<template>
    <div>
        <h2>{{$t('message.dashboard_heatmeters')}}</h2>
        <download-export-buttons resource="heat-meter" />
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <th>{{$t('message.heatmeter_label')}}</th>
                <th>{{$t('message.name')}}</th>
                <th>{{$t('message.building')}}</th>
                <th>{{$t('message.unit')}}</th>
                <th>{{$t('message.seal_number')}}</th>
                <th>{{$t('message.count_physical')}}</th>
                <th>{{$t('message.correction')}}</th>
                <th>{{$t('message.koeficient_polohy')}}</th>
                <th>{{$t('message.koeficient_svetove_strany')}}</th>
                <th>{{$t('message.transmitter_id')}}</th>
                <th>{{$t('message.last_data')}}</th>
                <th>{{$t('message.first_data')}}</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <template v-if="loading || transmitters.length === 0">
                <table-list-status :loading="loading" :colspan="13" />
            </template>
            <template v-else>
            <tr v-for="transmitter in transmitters" :key="transmitter.serial_number + '-' + transmitter.label">
                <td>
                    {{transmitter.label}}
                </td>
                <td>
                    {{transmitter.name}}
                </td>
                <td>
                    {{transmitter.building}}
                </td>
                <td>
                    {{transmitter.unit}}
                </td>
                <td>
                    {{transmitter.seal}}
                </td>
                <td>
                        <span>
                            <i class="fa fa-thermometer-three-quarters heat"></i> {{transmitter.count / 1000 | round(2)}} {{heatUnitLabel(transmitter.count / 1000)}}
                        </span>
                </td>
                <td>
                    {{transmitter.correction / 1000 | round(2)}} {{heatUnitLabel(transmitter.correction / 1000)}}
                </td>
                <td>
                    {{transmitter.koeficient_polohy}}
                </td>
                <td>
                    {{transmitter.koeficient_svetove_strany}}
                </td>
                <td>
                    {{transmitter.serial_number}}
                </td>
                <td>
                    {{transmitter.last_data}}
                </td>
                <td>
                    {{transmitter.first_data}}
                </td>
                <td>
                    <button class="btn btn-default" @click="openModal(transmitter)"><i class="fa fa-download"></i></button>
                </td>
            </tr>
            </template>
            </tbody>
        </table>
        <DownloadTransmitterData ref="downloadData"/>
    </div>
</template>

<script>
import mixins from '../modules/mixins'
import storage, {HEAT_METERS} from '../_store'
import Battery from './Battery'
import DownloadTransmitterData from './dashboard/modal/DownloadTransmitterData'
import DownloadExportButtons from './DownloadExportButtons'
import TableListStatus from './TableListStatus'

export default {
    name: 'HeatMeters',
    mixins: [mixins],
    components: {
        Battery,
        DownloadTransmitterData,
        DownloadExportButtons,
        TableListStatus
    },
    data () {
        return {
            loading: true,
            transmitters: []
        }
    },
    methods: {
        openModal (transmitter) {
            this.$refs['downloadData'].show(transmitter, 'heat')
        }
    },
    created () {
        storage.dispatch(HEAT_METERS)
            .then(resp => {
                this.transmitters = resp.data.transmitters.map((value) => {
                    const rawSerial = value.serial_number
                    const decoded = this.decodeITN(String(rawSerial).replace(/-/g, ''))
                    value.device_serial = rawSerial
                    value.serial_number = decoded != null ? decoded : rawSerial
                    return value
                });
            })
            .catch(err => {
                this.$b_notify({
                    type: 'danger',
                    content: err
                })
            })
            .finally(() => {
                this.loading = false
            })
    }
}
</script>

<style scoped>

</style>
